import { IconButton, Tooltip } from '@mui/material'
import styled from 'styled-components'
import { WbsItemIcon } from '../../../../components/icons/WbsItemIcon'
import { WbsItemTypeVO } from '../../../../../domain/value-object/WbsItemTypeVO'
import { memo } from 'react'

type Props = {
  value?: string
  wbsItemType: WbsItemTypeVO
  onClickIcon: (e: React.MouseEvent) => void
}

export const DisplayNameItem = memo(
  ({ value, wbsItemType, onClickIcon }: Props) => {
    return (
      <StyledContainer>
        <IconButton
          onClick={onClickIcon}
          sx={{ padding: '4px' }}
          data-no-dnd="true"
        >
          <WbsItemIcon type={wbsItemType} />
        </IconButton>
        <Tooltip title={value ?? ''} placement="top">
          <StyledDisplayName>{value}</StyledDisplayName>
        </Tooltip>
      </StyledContainer>
    )
  }
)

const StyledContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '4px',
})

const StyledDisplayName = styled('div')({
  width: '100%',
  fontSize: '14px',
  fontWeight: 600,
  padding: '4px 0',
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  textOverflow: 'ellipsis',
  lineHeight: '21px', // fontSize(14px) * 1.5
  minHeight: '42px', // lineHeight(21px) * 2行
  maxHeight: '42px', // lineHeight(21px) * 2行
})
